<template>
<div class="mobile-video-witness">
    <startWitness ref="startWitness"  @changeStep="changeStep"  v-if="currentStep == 'startWitness'" :collectionList="collectionList" @saveAnychatParam="saveAnychatParam" />
    <lineUp ref="lineUp"  @changeStep="changeStep"  v-if="currentStep == 'lineUp'" :collectionList="collectionList"
     :camera="camera" :microphone="microphone" :isOpenMode="isOpenMode" />
     <div class="fixed_btn operator-footer-btn-group" v-if="isShowVideoFooter">
      <el-button @click="goPrev"  id="videoPrevBtn" class="button light-button"  v-if="isShowPrev">上一步</el-button>
      <el-button @click="skipToNext"  class="button light-button-save" id="videoNextBtn"  v-if="isShowNext">下一步</el-button>
      <el-button class="skip" @click="skipToNext" v-if="isTest">跳过（仅测试用）</el-button>
    </div>

</div>
</template>

<script>
import startWitness from "./child/startWitness";
import lineUp from "./child/lineUp";
import { imgCommonMixins } from "./child/imgCommonMixins";
import {checkImgAndVideo } from "@/service/image-service";
import oppService from "@/service/opp-service.js";

export default{
  data () {
    return {
      currentStep: "startWitness", 
      collectionList : [],
      isShowPrev: true,
      isTest: false,
      isShowNext: true,
      isShowVideoFooter: true,
      ignoreImgCls: ["X35","X33","X13","070","119","x9999"],
      camera: "",//保存设置的anychat的摄像头
      microphone: "",//保存设置的anychat的麦克风
      isOpenMode: "", 
    };
  },
  mixins: [imgCommonMixins],
  activated (){
    this.currentStep = "startWitness";
  },
  props: ["bizData", "historyData", "oppBusiData", "groupDatas", "isDisabled"],
  mounted () {
    let that = this;
    that.currentStep = "startWitness";
    that.assembusiData(false, this.ignoreImgCls).then(res => {
      let allShowImgCls = that.reCollectImgItems.concat(that.eSignSealItems).concat(that.collectImgItems).concat(that.ocrIImgtems).concat(that.faceImgItems).concat(that.formItemItems);
      allShowImgCls = _.uniq(allShowImgCls, "IMG_CLS");
      allShowImgCls.forEach(item => {
        item && that.ignoreImgCls.indexOf(item.IMG_CLS) == -1  && that.collectionList.push(item.IMG_CLS_NAME);
      });
      that.collectionList = _.uniq(that.collectionList);      
      that.$store.commit(that.$types.UPDATE_LOADING, false);
      ;
      return true;
    });
  },
  computed:{
    busiCode () {
      return this.$store.state.busicode;
    },   
    B_SNO () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
  },
  components:{
    startWitness,
    lineUp,
  },
  methods:{
    changeStep (step){
      this.currentStep = step.type;
      if(step.type == "startWitness"){
        this.isShowVideoFooter = true;
        this.isShowNext = true;
        this.isShowPrev = true;
        if(step.isShowCollection){
          this.$nextTick(()=>{
            //做完视频见证，展示资料收集列表弹框
            this.$refs.startWitness.showCollectionList();
          });
        }
      }else{
        this.isShowVideoFooter = false;
      }
    },
    goPrev (){
      this.$router.goPrev();
    },
    saveAnychatParam (param){
      this.camera = param.camera;
      this.microphone = param.microphone;
      this.isOpenMode = param.isOpenMode;
    },
    async validate (){
      if(this.isDisabled){
        //页面禁用，说明不需要校验
        return true;
      }
      let res = await checkImgAndVideo(this);
      if (res.flagImg) {
        // 免冠照丢失通知后台补数据
        this.alert("免冠照未保存成功，请重新见证。");
        return false;
      } else if (res.flagVideo) {
        //见证视频未保存成功，提示错误，并退出组件重新录制
        this.alert("见证/风险揭示视频未保存成功，请重新见证。");
        return false;
      }
      return true;
    },
    async skipToNext () {
      let flag = await this.validate();
      //无编辑权限，只有见证岗权限时，下一步不更新nodeCode
      if(!this.editAuth && this.witnessAuth){
        this.alert("见证结束，数据保存成功！");
        return;
      }
      if(!flag){
        return;
      }
      //下一步仅更新nodecode
      return oppService.updateNodeCode().then(()=>{
        this.$router.goNext();
      });
    },
  }
};
 
</script>
<style lang="less"  scoped>
.mobile-video-witness{
  height: 100%;
  .white-box{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/imageNode/mobile_video_witness.vue